export default __webpack_public_path__ + "static/media/green-bird2.dd41620e.png";